import actions from './module-supplier-only-down-actions';
import getters from './module-supplier-only-down-getters';
import mutations from './module-supplier-only-down-mutation';
import state from './module-supplier-only-down-state.js';

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
